import React, { ReactElement } from 'react';

import { appReactMemo } from 'hocs';
import { useBreakpoint } from 'hooks/adaptive/useBreakpoint';

import BreadCrumb from '../BreadCrumb';

import {
  Body,
  ButtonsContainer,
  Container,
  Header,
  TitleBlock,
  ViewTitle,
} from './styled';

interface PageContainerProps {
  children?: React.ReactNode;
  renderButtons?: ReactElement;
  showBreadCrumb?: boolean;
  title: ReactElement | string;
}

const PageContainer = ({
  children,
  renderButtons,
  showBreadCrumb = false,
  title,
}: PageContainerProps) => {
  const checkWindowWidth = useBreakpoint();

  const getTitleSize = () => {
    if (showBreadCrumb) return 'h3';
    return checkWindowWidth(900) ? 'h4' : 'h1';
  };

  return (
    <Container>
      <Header>
        <TitleBlock>
          <ViewTitle as={getTitleSize()}>{title}</ViewTitle>
          {showBreadCrumb && <BreadCrumb />}
        </TitleBlock>
        <ButtonsContainer>{renderButtons}</ButtonsContainer>
      </Header>
      <Body data-testid='pageContainerBody'>{children}</Body>
    </Container>
  );
};

export default appReactMemo(PageContainer);
